module.exports = __webpack_public_path__ + "img/logos_whatsapp-icon.426d5c8e.png";